// Las fichas de referencia de una card (miniatura + rótulo), las mismas en la card de
// imagen y en la de video (ADR-2026-09-25-las-referencias-se-ven-en-la-card). Con `onQuitar`
// cada una lleva su ✕ y `agregar` va al final: la card de imagen deja editarlas
// (ADR-2026-10-20-las-referencias-de-la-card-se-editan). Sin eso, sólo lectura, como siempre.
import React from 'react';
import { X } from 'lucide-react';
import CachedImg from '../../../components/CachedImg';
import type { FichaDeReferencia } from '../miniaturasDeReferencias';

export const ChipsDeReferencias: React.FC<{
  fichas: FichaDeReferencia[];
  onQuitar?: (ficha: FichaDeReferencia) => void;
  /** Lo que va después de las fichas (el "+ Agregar" de la card). */
  agregar?: React.ReactNode;
}> = ({ fichas, onQuitar, agregar }) => (
  <div className="flex flex-wrap gap-1.5">
    {fichas.map((c, i) => (
      <span key={i} className={`flex items-center gap-1.5 bg-[#F7F7F9] rounded-full pl-1 py-0.5 ${onQuitar && c.origen ? 'pr-1' : 'pr-3'}`}>
        {c.thumb ? (
          <CachedImg src={c.thumb} alt={c.label} className="w-5 h-5 rounded-full object-cover" />
        ) : (
          <span className="w-5 h-5 rounded-full bg-black/[0.06]" aria-hidden="true" />
        )}
        <span className="text-[12.5px] font-medium text-brand-black/85 truncate max-w-[160px]">{c.label}</span>
        {onQuitar && c.origen && (
          <button
            type="button"
            onClick={() => onQuitar(c)}
            aria-label={`Sacar ${c.label}`}
            className="inline-flex h-5 w-5 items-center justify-center rounded-full text-brand-black/45 transition-colors hover:bg-black/[0.06] hover:text-brand-black/80"
          >
            <X className="h-3 w-3" strokeWidth={2.5} />
          </button>
        )}
      </span>
    ))}
    {agregar}
  </div>
);
